"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StackedDrawerContext = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _reactTransitionGroup = require("react-transition-group");

var _index = require("../DrawerStack/index");

var _drawerReducer = require("../DrawerStack/drawerReducer");

var _Drawer = require("../Drawer");

var _index2 = require("./index.styles");

var _FocusContainer = _interopRequireDefault(require("./FocusContainer"));

var _excluded = ["id", "parentId", "noMask", "autoFocus", "skipOpenAnimation", "afterHide", "children"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
} // Used by Header to close


var StackedDrawerContext = /*#__PURE__*/(0, _react.createContext)();
exports.StackedDrawerContext = StackedDrawerContext;

var StackedDrawer = function StackedDrawer(_ref) {
  var id = _ref.id,
      parentId = _ref.parentId,
      noMask = _ref.noMask,
      autoFocus = _ref.autoFocus,
      skipOpenAnimation = _ref.skipOpenAnimation,
      afterHide = _ref.afterHide,
      children = _ref.children,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var drawerStackContext = (0, _react.useContext)(_index.DrawerStackContext);

  if (!drawerStackContext) {
    throw Error("No DrawerStack found: use `withDrawerStack()` around the parent of <StackedDrawer id=".concat(id, ">."));
  }

  var _useState = (0, _react.useState)(skipOpenAnimation),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      inProp = _useState2[0],
      setInProp = _useState2[1];

  var drawerStack = drawerStackContext.drawerStack,
      createDrawer = drawerStackContext.createDrawer,
      hideDrawer = drawerStackContext.hideDrawer,
      resetDrawer = drawerStackContext.resetDrawer;
  var drawerConfig = drawerStack.get(id);
  var state = drawerConfig && drawerConfig.state || _drawerReducer.DRAWER_STATE_NOSTACK;
  var hasOpenChildDrawer = !!(drawerConfig && drawerConfig.openChildId);
  var renderNoMask = parentId ? true : noMask;
  var close = (0, _react.useCallback)(function () {
    if (state === _drawerReducer.DRAWER_STATE_SHOW) {
      hideDrawer(id);
    }
  }, [hideDrawer, id, state]);

  var exitHandler = function exitHandler() {
    if (state === _drawerReducer.DRAWER_STATE_HIDE) {
      resetDrawer(id);
      afterHide();
    }
  };

  (0, _react.useEffect)(function () {
    switch (state) {
      case _drawerReducer.DRAWER_STATE_NOSTACK:
        createDrawer(id, parentId);
        break;

      case _drawerReducer.DRAWER_STATE_SHOW:
        setInProp(true);
        break;

      case _drawerReducer.DRAWER_STATE_HIDE:
        setInProp(false);
        break;

      default:
    }
  }, [createDrawer, id, parentId, state]); // Config will be available at next render

  if (!drawerConfig) return null; // Wait for next render when `setInProp` has een processed

  if (skipOpenAnimation && state === _drawerReducer.DRAWER_STATE_SHOW && !inProp) return null;
  var showDrawer = state === _drawerReducer.DRAWER_STATE_SHOW || state === _drawerReducer.DRAWER_STATE_HIDE;
  return showDrawer && /*#__PURE__*/_react["default"].createElement(_index2.Container, props, !renderNoMask ? /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, {
    "in": inProp,
    appear: skipOpenAnimation,
    timeout: 0,
    classNames: "fade-in"
  }, /*#__PURE__*/_react["default"].createElement(_index2.Mask, {
    "data-mask": true
  })) : null, /*#__PURE__*/_react["default"].createElement(_FocusContainer["default"], {
    close: close,
    state: state,
    inProp: inProp,
    noMask: renderNoMask,
    autoFocus: autoFocus,
    parentId: parentId,
    hasOpenChildDrawer: hasOpenChildDrawer
  }, /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, {
    "in": inProp && !!hasOpenChildDrawer,
    timeout: {
      appear: 0,
      enter: _Drawer.ANIMATION_SPEED_ENTER,
      exit: _Drawer.ANIMATION_SPEED_EXIT
    },
    classNames: "slide-aside"
  }, /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, {
    "in": inProp,
    appear: skipOpenAnimation,
    timeout: {
      appear: 0,
      enter: _Drawer.ANIMATION_SPEED_ENTER,
      exit: _Drawer.ANIMATION_SPEED_EXIT
    },
    classNames: "slide-in",
    onExited: exitHandler
  }, /*#__PURE__*/_react["default"].createElement(_index2.DrawerContent, {
    "data-testid": "content",
    "data-drawer": id
  }, /*#__PURE__*/_react["default"].createElement(StackedDrawerContext.Provider, {
    value: {
      close: close
    }
  }, children))))));
};

StackedDrawer.propTypes = {
  id: _propTypes.string.isRequired,
  parentId: _propTypes.string,
  noMask: _propTypes.bool,
  autoFocus: _propTypes.bool,
  skipOpenAnimation: _propTypes.bool,
  afterHide: _propTypes.func,
  children: _propTypes.node.isRequired
};
StackedDrawer.defaultProps = {
  parentId: '',
  noMask: false,
  autoFocus: false,
  skipOpenAnimation: false,
  afterHide: function afterHide() {}
};
var _default = StackedDrawer;
exports["default"] = _default;